var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 4C38.0943 4 29.8774 6.49258 22.8883 11.1625C15.8992 15.8325 10.4519 22.4701 7.23514 30.236C4.01841 38.0018 3.17677 46.5471 4.81664 54.7913C6.45652 63.0355 10.5042 70.6083 16.448 76.552C22.3917 82.4958 29.9645 86.5435 38.2087 88.1834C46.4529 89.8232 54.9982 88.9816 62.7641 85.7649C70.5299 82.5481 77.1675 77.1008 81.8375 70.1117C86.5074 63.1226 89 54.9057 89 46.5C89 35.2283 84.5223 24.4183 76.552 16.448C68.5817 8.47766 57.7717 4 46.5 4ZM46.5 82.9286C39.2951 82.9286 32.252 80.7921 26.2614 76.7892C20.2707 72.7864 15.6016 67.097 12.8444 60.4406C10.0872 53.7841 9.36581 46.4596 10.7714 39.3931C12.177 32.3267 15.6465 25.8357 20.7411 20.7411C25.8358 15.6465 32.3267 12.177 39.3932 10.7714C46.4596 9.36579 53.7842 10.0872 60.4406 12.8444C67.0971 15.6016 72.7864 20.2707 76.7893 26.2614C80.7921 32.252 82.9286 39.2951 82.9286 46.5C82.9286 56.1614 79.0906 65.4272 72.2589 72.2589C65.4272 79.0906 56.1615 82.9286 46.5 82.9286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4598 44.3356L37.6371 28.4103C37.1663 28.141 36.6321 27.9995 36.0884 28C35.5447 28.0005 35.0107 28.1431 34.5404 28.4133C34.0701 28.6836 33.68 29.0719 33.4096 29.5392C33.1391 30.0065 32.9979 30.5361 33 31.0747V62.9253C32.9979 63.4639 33.1391 63.9935 33.4096 64.4608C33.68 64.9281 34.0701 65.3164 34.5404 65.5866C35.0107 65.8569 35.5447 65.9995 36.0884 66C36.6321 66.0005 37.1663 65.859 37.6371 65.5897L65.4598 49.6644C65.9282 49.3952 66.3171 49.0088 66.5874 48.5439C66.8577 48.079 67 47.5518 67 47.0153C67 46.4788 66.8577 45.9517 66.5874 45.4868C66.3171 45.0218 65.9282 44.6354 65.4598 44.3662V44.3356Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayIcon);
export default __webpack_public_path__ + "static/media/ic_playIcon.7cfe3a78.svg";
export { ForwardRef as ReactComponent };